/*
const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu) { // Check if the element exists to prevent errors
    const detailsItems = inlineMenu.querySelectorAll("details");
    detailsItems.forEach(item => {
        const ulElement = item.querySelector("ul");
        if (ulElement) { // Check if the ul element exists
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
        });
        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        ulElement.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
        });
        }
    });
}
    */

document.querySelectorAll('.mega-menu > summary').forEach(summary => {

  summary.addEventListener('click', () => {

    const details = summary.parentElement;

    requestAnimationFrame(() => {

      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }

    });

  });

});

// setTimeout(function() {
//     var windowsize = $(window).width();
//     console.log(windowsize);
//     if(windowsize <  990){

//         function waitForElement(selector, callback) {
//         const interval = setInterval(function() {
//             const element = $(selector);
//                 if (element.length) {
//                     clearInterval(interval);
//                     callback(element);
//                 }
//             }, 100); // Check every 100ms
//         }

//         // Usage:
//         waitForElement('.related-products ul.product-grid', function(element) {
//             console.log('Element found:', element);
//             element.addClass('highlighted');
//             reloadSlider();
//         });

//         function reloadSlider(){
//         console.log($('.related-products-slider').length);
//         $('.related-products-slider').slick({
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             centerMode: false,
//             arrows: false,
//             dots: true,
//             centerPadding: '10px'
//         });
//         }

//         $(window).resize(function(){
//         reloadSlider();
//         });

//     }
// }, 200);

setTimeout(function() {
  const windowsize = $(window).width();

  if (windowsize < 990) {
    function waitForElement(selector, callback, timeout = 10000) {
      const $element = $(selector);
      if ($element.length) {
        callback($element);
        return;
      }

      const observer = new MutationObserver(function(mutations, obs) {
        const $el = $(selector);
        if ($el.length) {
          obs.disconnect();
          callback($el);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function() {
        observer.disconnect();
      }, timeout);
    }

    function reloadSlider() {
      const $slider = $('.related-products-slider');

      if (!$slider.length) {
        return;
      }

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: false,
        dots: true,
        centerPadding: '10px'
      });
    }

    waitForElement('.related-products ul.product-grid', function(element) {
      element.addClass('highlighted');
      reloadSlider();
    });

    let relatedSliderResizeTimer;

    $(window).on('resize', function() {
      clearTimeout(relatedSliderResizeTimer);

      relatedSliderResizeTimer = setTimeout(function() {
        reloadSlider();
      }, 200);
    });
  }
}, 200);

$('input[name="quantity_sticky"]').change(function() {
    var qty = $(this).val();
    console.log('Input value changed to: ' + qty);
    $('input[name="quantity"]').val(qty);
});

$('input[name="quantity"]').change(function() {
    var qty = $(this).val();
    console.log('Input value changed to: ' + qty);
    $('input[name="quantity_sticky"]').val(qty);
});


$('button.sticky-atc-btn').click(function() {
   // $('.product-form button.product-form__submit').click();

    $('html, body').animate({ scrollTop: 0 }, 400);

    setTimeout(function() {
        var notifyText = $('.wrapp-btn-buy .wr-alert-qty').html();
        $('.sticky_notify').html(notifyText);
    }, 700);
});

$('button.product-form__submit').click(function() {
    console.log('product-form__submit main click');
  setTimeout(function() {
    var notifyText = $('.wrapp-btn-buy .wr-alert-qty').html();
    $('.sticky_notify').html(notifyText)
  }, 700);
});

/*
$('.btn-update-select.desktop.select-country').click(function() {
   $('form#HeaderCountryForm').submit();
});
$('.btn-update-select.mobile.select-country').click(function() {
   $('form#HeaderCountryMobileForm').submit();
});
*/

$('.btn-update-select.desktop.select-country').click(function() {
  document
    .querySelector('#HeaderCountryForm')
    ?.requestSubmit();
});

$('.btn-update-select.mobile.select-country').click(function() {
  document
    .querySelector('#HeaderCountryMobileForm')
    ?.requestSubmit();
});


$('.open-search-feature, .faq-minimalist__search').click(function(e) {
     //$('#ygc-search-widget-root textarea.textarea').focus();
    
     e.preventDefault();
     var $iframe = $('#ygc-search-iframe');
     if ($iframe.length && !$iframe.attr('src') && $iframe.data('src')) {
       $iframe.attr('src', $iframe.data('src'));
     }
     $('#popup-ygc-search-widget').css('display','flex');
     //$('body').addClass('overflow-hidden');
     //$('.ygpts-widgetBtn').click();
    
});

$('a[href*="#open-ai-search"]').on('click', function(e) {
     e.preventDefault();
     var $iframe = $('#ygc-search-iframe');
     if ($iframe.length && !$iframe.attr('src') && $iframe.data('src')) {
       $iframe.attr('src', $iframe.data('src'));
     }
     $('#popup-ygc-search-widget').css('display','flex');
     //$('body').addClass('overflow-hidden');
});

$('a[href*="#open-ai-chat"]').on('click', function(e) {
     e.preventDefault(); 
    //$('#popup-ygc-search-widget').css('display','flex');

     const $menuDrawerContainer = $('#Details-menu-drawer-container');

     if ($menuDrawerContainer.hasClass('menu-opening') || $menuDrawerContainer.is('[open]')) {
         $menuDrawerContainer.find('summary').click();
         
         setTimeout(function() {
             $('.ygpts-widgetBtn').click();
         }, 200); 
     } else {
         $('.ygpts-widgetBtn').click();
     }
});


$('#popup-ygc-search-widget .close-popup-ygc-search').click(function() {
    $('#popup-ygc-search-widget').css('display','none');
     //$('body').removeClass('overflow-hidden');
     console.log(123);
});

$('#ai-search-trigger').click(function(e) {
  //$('div[id="ygc-search-widget-root"]').addClass('active');
     //$('#ygc-search-widget-root textarea.textarea').focus();
     //$(' #popup-ygc-search-widget').css('display','flex');
      e.preventDefault();
      $('.ygpts-widgetBtn').click();
});



$(".shipping-returns__according .accordion__button").click(function() {
    $(this).toggleClass("opened");
    $(this).next().slideToggle();
});



async function productBundleATC(productId, event) {
    event?.preventDefault();
    event?.stopPropagation();

    const bundleSelect = document.querySelector(`.product_bundle_${productId}`);
    const bundleItem = document.querySelector(`.bundle_item_${productId}`);
    const atcButton = document.querySelector(`#product_bundle_atc_${productId} button.add-to-cart`);

    if (!bundleSelect) return;

    const bundleVariantId = Number(bundleSelect.value);

    // Variant hiện đang được chọn của Main Product
    const mainVariantInput = document.querySelector(
        'form[action*="/cart/add"] input[name="id"].product-variant-id'
    );
 
    if (!mainVariantInput) {
        console.error("Cannot find main product variant.");
        return;
    }

    const mainVariantId = Number(mainVariantInput.value);

    bundleItem?.classList.add("btn--loading");
    atcButton?.classList.add("btn--loading");

    try {

        // Lấy cart hiện tại
        const cartData = await fetch(`${window.Shopify.routes.root}cart.js`)
            .then(res => res.json());

        const hasMainProduct = cartData.items.some(item =>
            item.variant_id === mainVariantId
        );

        const items = [];

        // Nếu main chưa có thì add trước
        if (!hasMainProduct) {
            items.push({
                id: mainVariantId,
                quantity: 1
            });
        }

        // Sau đó add bundle
        items.push({
            id: bundleVariantId,
            quantity: 1
        });

        const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");

        const sections = cart?.getSectionsToRender?.().map(section => section.id) || [];

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                items,
                sections
            })
        });

        const responseData = await response.json();

        if (responseData.status) {
            throw new Error(responseData.description);
        }

        document.dispatchEvent(new CustomEvent("cart:build"));

        cart?.renderContents?.(responseData);

        cart?.classList.remove("is-empty");

        setTimeout(() => {
            document.querySelector("#cart-icon-bubble")?.click();
        }, 300);

    } catch (error) {

        console.error(error);

    } finally {

        bundleItem?.classList.remove("btn--loading");
        atcButton?.classList.remove("btn--loading");

    }
}



$(document).ready(function(){
$('a[href="#all-reviews"')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
    // On-page links
    if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
    ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
        event.preventDefault();
        $('html, body').animate({
        scrollTop: target.offset().top - 100
        }, 1000, function() {
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { 
            return false;
        } else {
            $target.attr('tabindex','-1'); 
            $target.focus(); 
        };
        });
    }
    }
});
});

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.custom-accordion-group');

    accordions.forEach((details) => {
      const summary = details.querySelector('summary');
      
      summary.addEventListener('click', (event) => {
        if (!details.hasAttribute('open')) {
          accordions.forEach((otherDetails) => {
            if (otherDetails !== details) {
              otherDetails.removeAttribute('open');
              otherDetails.querySelector('summary').setAttribute('aria-expanded', false);
            }
          });
          summary.setAttribute('aria-expanded', true);
        } else {
          summary.setAttribute('aria-expanded', false);
        }
      });
    });
  });



